import api_fetch from "../utils/api_fetch";
import { storageHandler } from '../utils/storage_handler';

const simplefin = {
  getAccountsPaginated: async function ({ page = 1, pageSize = 50, keyword = '', customerName = null, bankName = null, status = null, minBalance = null, maxBalance = null, minCreditLine = null, maxCreditLine = null, lastSyncStatus = null, orderBy = 'name', orderDirection = 'ASC' } = {}) {
    try {
      const params = { page, pageSize, keyword, customerName, bankName, status, minBalance, maxBalance, minCreditLine, maxCreditLine, lastSyncStatus, orderBy, orderDirection };
      Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);
      const response = await api_fetch.get(
        '/v1/simplefin-accounts-paginated',
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        params,
        ""
      );
      return await response.json();
    } catch (error) {
      console.error('Error fetching SimpleFIN paginated accounts:', error);
      throw error;
    }
  },

  getDistinctCustomers: async function() {
    try {
      const response = await api_fetch.get(
        `/v1/simplefin-distinct-customers`,
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        {},
        ""
      );
      return await response.json();
    } catch (error) {
      console.error('Error fetching distinct customers:', error);
      throw error;
    }
  },

  getDistinctBanks: async function() {
    try {
      const response = await api_fetch.get(
        `/v1/simplefin-distinct-banks`,
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        {},
        ""
      );
      return await response.json();
    } catch (error) {
      console.error('Error fetching distinct banks:', error);
      throw error;
    }
  },

  getLoginsForCustomerAndBank: async function(customerName = '', bankName = '') {
    try {
      const params = {};
      if (customerName) params.customerName = customerName;
      if (bankName) params.bankName = bankName;
      const response = await api_fetch.get(
        `/v1/simplefin-logins`,
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        params,
        ""
      );
      return await response.json();
    } catch (error) {
      console.error('Error fetching simplefin logins for customer and bank:', error);
      throw error;
    }
  },

  updateAccountStatus: async function(id, status) {
    try {
      const body = { status };
      const res = await api_fetch.patch(
        `/v1/simplefin-account/${id}/status`,
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        {},
        '',
        body
      );
      return await res.json();
    } catch (error) {
      console.error('Error updating SimpleFIN account status:', error);
      throw error;
    }
  }
};

// Status labels (reuse common endpoints)
simplefin.getStatusLabels = async function() {
  try {
    const response = await api_fetch.get('/v1/status-labels', { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` }, {}, '');
    const data = await response.json();
    return data.result || ['Active', 'Exiting'];
  } catch (error) {
    console.error('Error fetching status labels:', error);
    return ['Active', 'Exiting'];
  }
};

simplefin.updateStatusLabels = async function(arr) {
  try {
    const res = await api_fetch.post('/v1/status-labels', { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` }, {}, '', { labels: arr });
    return await res.json();
  } catch (error) {
    console.error('Error updating status labels:', error);
    throw error;
  }
};

// Notes use existing buxfer endpoints for now
simplefin.listNotes = async function(accountId) {
  const res = await api_fetch.get(`/v1/buxfer-account/${accountId}/notes`, { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` }, {}, '');
  return await res.json();
};

simplefin.createNote = async function(accountId, author, text) {
  const res = await api_fetch.post(`/v1/buxfer-account/${accountId}/notes`, { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` }, {}, '', { author, text });
  return await res.json();
};

simplefin.updateNote = async function(noteId, text) {
  const res = await api_fetch.put(`/v1/buxfer-account/notes/${noteId}`, { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` }, {}, '', { text });
  return await res.json();
};

simplefin.deleteNote = async function(noteId) {
  const res = await api_fetch.delete(`/v1/buxfer-account/notes/${noteId}`, { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` }, {}, '', {});
  return await res.json();
};

export default simplefin;
